{
  "Shared": {
    "navigationBlocker": {
      "title": "Nicht gespeicherte Änderungen",
      "description": "Sie haben nicht gespeicherte Änderungen, die verloren gehen, wenn Sie diese Seite verlassen. Möchten Sie wirklich fortfahren?",
      "cancel": "Abbrechen",
      "confirm": "Seite verlassen"
    }
  },
  "Common": {
    "noImage": "Kein Bild",
    "soldOut": "Ausverkauft",
    "sale": "Sale",
    "loading": "Wird geladen...",
    "error": "Ein Fehler ist aufgetreten",
    "retry": "Erneut versuchen",
    "back": "Zurück",
    "inviteTitle": "Menschen zu Postolar Varga einladen",
    "inviteDescription": "Kennen Sie jemanden, der unsere Produkte lieben würde? Teilen Sie sie mit dieser Person!",
    "inviteButton": "Teilen",
    "previous": "Zurück",
    "next": "Weiter",
    "basePrice": "Basispreis"
  },
  "Footer": {
    "about": {
      "title": "Über uns",
      "description": "Wir produzieren besonders bequeme Lederhausschuhe mit anatomischer Sohle, die Schmerzen in Füßen, Waden, Fersen und Fersensporn lindern kann. Naturleder und Handarbeit garantieren hochwertige anatomische Hausschuhe zu fairen Preisen. Außerdem bieten wir die Fertigung von Taschen, Gürteln und weiteren Lederwaren an."
    },
    "information": {
      "title": "Informationen",
      "aboutUs": "Über uns",
      "deliveryInfo": "Lieferinformationen",
      "privacyPolicy": "Datenschutzerklärung",
      "termsAndConditions": "Allgemeine Geschäftsbedingungen",
      "contactUs": "Kontakt",
      "returns": "Rückgaberichtlinie",
      "paymentOptions": "Zahlungsarten",
      "faq": "Häufig gestellte Fragen",
      "withdrawal": "Vertrag widerrufen",
      "withdrawalForm": "Widerrufsformular",
      "complaints": "Beschwerden und Reklamationen",
      "cookies": "Cookie-Richtlinie",
      "cookieSettings": "Cookie-Einstellungen",
      "priceList": "Preisliste"
    },
    "customerSupport": {
      "title": "Kundenservice",
      "siteMap": "Sitemap",
      "orderHistory": "Bestellhistorie",
      "wishList": "Wunschliste",
      "giftCards": "Geschenkgutscheine",
      "specialOffers": "Angebote",
      "newsletter": "Newsletter"
    },
    "social": {
      "title": "Soziale Netzwerke",
      "followOnInstagram": "Auf Instagram folgen",
      "followOnFacebook": "Auf Facebook folgen"
    },
    "copyright": "© {{year}} Postolar Varga. Alle Rechte vorbehalten."
  },
  "StaticPages": {
    "AboutUs": {
      "title": "Über uns",
      "content": "Wir produzieren besonders bequeme Lederhausschuhe mit anatomischer Sohle, die Schmerzen in Füßen, Waden, Fersen und Fersensporn lindern kann. Naturleder und Handarbeit garantieren hochwertige anatomische Hausschuhe zu fairen Preisen. Außerdem bieten wir die Fertigung von Taschen, Gürteln und weiteren Lederwaren an."
    },
    "breadcrumbs": {
      "home": "Startseite"
    },
    "onThisPage": "Auf dieser Seite",
    "groups": {
      "information": "Informationen",
      "legal": "Rechtliches"
    }
  },
  "Account": {
    "title": "Mein Konto",
    "backToAccount": "Zurück zum Konto",
    "orders": {
      "title": "Bestellungen",
      "description": "Bestellhistorie ansehen und Sendungen verfolgen",
      "empty": "Sie haben noch keine Bestellungen aufgegeben.",
      "startShopping": "Einkaufen beginnen",
      "orderNumber": "Bestellung",
      "items": "{{count}} Artikel",
      "viewDetails": "Details ansehen",
      "loadMore": "Mehr laden",
      "loading": "Wird geladen...",
      "backToOrders": "Zurück zu den Bestellungen",
      "status": "Bestellstatus",
      "statusProcessing": "In Bearbeitung",
      "orderItems": "Bestellartikel",
      "shippingAddress": "Lieferadresse",
      "orderSummary": "Bestellübersicht",
      "subtotal": "Zwischensumme",
      "shipping": "Lieferung",
      "tax": "MwSt.",
      "total": "Gesamt",
      "tracking": "Sendungsverfolgung",
      "trackingNumber": "Sendungsnummer",
      "notFound": "Bestellung nicht gefunden.",
      "financialStatuses": {
        "AUTHORIZED": "Autorisiert",
        "EXPIRED": "Abgelaufen",
        "PAID": "Bezahlt",
        "PARTIALLY_PAID": "Teilweise bezahlt",
        "PARTIALLY_REFUNDED": "Teilweise erstattet",
        "PENDING": "Ausstehend",
        "REFUNDED": "Erstattet",
        "VOIDED": "Storniert"
      },
      "fulfillmentStatuses": {
        "FULFILLED": "Erfüllt",
        "IN_PROGRESS": "In Bearbeitung",
        "ON_HOLD": "Zurückgestellt",
        "OPEN": "Offen",
        "PARTIALLY_FULFILLED": "Teilweise erfüllt",
        "PENDING_FULFILLMENT": "Erfüllung ausstehend",
        "READY_FOR_DELIVERY": "Bereit zur Lieferung",
        "READY_FOR_PICKUP": "Bereit zur Abholung",
        "RESTOCKED": "Wieder aufgefüllt",
        "SCHEDULED": "Geplant",
        "UNFULFILLED": "Nicht erfüllt"
      }
    },
    "addresses": {
      "title": "Adressen",
      "description": "Liefer- und Rechnungsadressen verwalten",
      "empty": "Sie haben keine gespeicherten Adressen.",
      "addFirst": "Erste Adresse hinzufügen",
      "addNew": "Adresse hinzufügen",
      "default": "Standard",
      "edit": "Bearbeiten",
      "delete": "Löschen",
      "setDefault": "Als Standard festlegen",
      "editTitle": "Adresse bearbeiten",
      "addTitle": "Neue Adresse hinzufügen",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "company": "Firma",
      "address1": "Adresse",
      "address2": "Adresszusatz",
      "city": "Stadt",
      "zip": "Postleitzahl",
      "territoryCode": "Land",
      "territoryCodeHint": "Wählen Sie ein Land aus der Liste",
      "countryPlaceholder": "Land auswählen...",
      "countryLoading": "Länder werden geladen...",
      "countryNoResults": "Keine Ergebnisse",
      "zoneCode": "Region / Bundesland (ISO-Code)",
      "zoneCodeHint": "z. B. 21 für Split",
      "phoneNumber": "Telefon",
      "setAsDefault": "Als Standardadresse festlegen",
      "save": "Speichern",
      "cancel": "Abbrechen",
      "saving": "Wird gespeichert...",
      "saved": "Adresse gespeichert",
      "saveError": "Fehler beim Speichern der Adresse",
      "deleteConfirm": "Sind Sie sicher?",
      "deleteYes": "Ja, löschen",
      "deleted": "Adresse gelöscht",
      "deleteError": "Fehler beim Löschen",
      "defaultSet": "Standardadresse festgelegt",
      "defaultSetError": "Fehler beim Festlegen der Standardadresse",
      "unsavedChanges": "Sie haben nicht gespeicherte Änderungen. Seite verlassen?",
      "errorCodes": {
        "ADDRESS1_MISSING": "Adresse ist erforderlich.",
        "ADDRESS_ARGUMENT_EMPTY": "Adressdaten sind leer.",
        "ADDRESS_ID_DOES_NOT_EXIST": "Adresse existiert nicht.",
        "CONTAINS_HTML_TAGS": "Das Feld enthält unzulässige HTML-Tags.",
        "COUNTRY_NOT_EXIST": "Das ausgewählte Land existiert nicht.",
        "CUSTOMER_ADDRESS_ALREADY_EXISTS": "Diese Adresse ist bereits gespeichert.",
        "DELETING_CUSTOMER_DEFAULT_ADDRESS_NOT_ALLOWED": "Die Standardadresse kann nicht gelöscht werden. Legen Sie zuerst eine andere Adresse als Standard fest.",
        "DEMOTING_CUSTOMER_DEFAULT_ADDRESS_NOT_ALLOWED": "Die Standardadresse kann nicht als Standard entfernt werden.",
        "INVALID": "Ungültiges Feld.",
        "INVALID_FOR_COUNTRY": "Der Wert ist für das ausgewählte Land ungültig.",
        "INVALID_FOR_COUNTRY_AND_PROVINCE": "Der Wert ist für das ausgewählte Land und die Region ungültig.",
        "INVALID_TERRITORY_CODE": "Ungültiger Ländercode.",
        "PHONE_NUMBER_NOT_VALID": "Ungültige Telefonnummer.",
        "REQUIRED": "Dieses Feld ist erforderlich.",
        "TERRITORY_CODE_MISSING": "Land ist erforderlich.",
        "TOO_LONG": "Der Wert ist zu lang.",
        "ZONE_CODE_MISSING": "Region ist erforderlich."
      }
    },
    "profile": {
      "title": "Profil",
      "description": "Persönliche Daten aktualisieren",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "email": "E-Mail",
      "phone": "Telefon",
      "newsletter": "Newsletter für exklusive Angebote abonnieren",
      "save": "Änderungen speichern",
      "cancel": "Abbrechen",
      "saving": "Wird gespeichert...",
      "saved": "Änderungen gespeichert",
      "saveError": "Fehler beim Speichern",
      "emailReadOnly": "Die E-Mail kann hier nicht geändert werden. Kontaktieren Sie den Support.",
      "phoneReadOnly": "Die Telefonnummer kann hier nicht geändert werden.",
      "unsavedChanges": "Sie haben nicht gespeicherte Änderungen. Seite verlassen?"
    },
    "logout": {
      "title": "Abmelden",
      "description": "Von Ihrem Konto abmelden"
    },
    "countries": {
      "AT": "Österreich",
      "BE": "Belgien",
      "BG": "Bulgarien",
      "CY": "Zypern",
      "CZ": "Tschechien",
      "DE": "Deutschland",
      "DK": "Dänemark",
      "EE": "Estland",
      "ES": "Spanien",
      "FI": "Finnland",
      "FR": "Frankreich",
      "GR": "Griechenland",
      "HR": "Kroatien",
      "HU": "Ungarn",
      "IE": "Irland",
      "IT": "Italien",
      "LT": "Litauen",
      "LU": "Luxemburg",
      "LV": "Lettland",
      "MT": "Malta",
      "NL": "Niederlande",
      "PL": "Polen",
      "PT": "Portugal",
      "RO": "Rumänien",
      "SE": "Schweden",
      "SI": "Slowenien",
      "SK": "Slowakei"
    }
  },
  "Auth": {
    "completingLogin": "Anmeldung wird abgeschlossen...",
    "login": {
      "title": "Anmelden",
      "email": "E-Mail",
      "emailPlaceholder": "Geben Sie Ihre E-Mail ein",
      "password": "Passwort",
      "passwordPlaceholder": "Geben Sie Ihr Passwort ein",
      "rememberMe": "Angemeldet bleiben",
      "forgotPassword": "Passwort vergessen?",
      "submit": "Anmelden",
      "noAccount": "Sie haben kein Konto?",
      "signUp": "Registrieren"
    },
    "register": {
      "title": "Konto erstellen",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "email": "E-Mail",
      "password": "Passwort",
      "passwordHint": "Das Passwort muss mindestens 8 Zeichen lang sein",
      "confirmPassword": "Passwort bestätigen",
      "terms": "Ich stimme den",
      "termsLink": "Nutzungsbedingungen",
      "and": "und der",
      "privacyLink": "Datenschutzrichtlinie",
      "newsletter": "Abonnieren Sie unseren Newsletter für Neuigkeiten und Angebote",
      "submit": "Konto erstellen",
      "hasAccount": "Sie haben bereits ein Konto?",
      "signIn": "Anmelden"
    },
    "forgotPassword": {
      "title": "Passwort vergessen",
      "description": "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen des Passworts.",
      "email": "E-Mail",
      "emailPlaceholder": "Geben Sie Ihre E-Mail ein",
      "submit": "Reset-Link senden",
      "backToLogin": "Zurück zur Anmeldung"
    }
  },
  "Blog": {
    "title": "Blog",
    "subtitle": "Tipps für Fuß- und Beingesundheit",
    "readMore": "Weiterlesen",
    "publishedAt": "Veröffentlicht",
    "author": "Autor",
    "relatedArticles": "Ähnliche Artikel",
    "backToBlog": "Zurück zum Blog",
    "noArticles": "Derzeit sind keine Artikel veröffentlicht.",
    "breadcrumbs": {
      "home": "Startseite",
      "blog": "Blog"
    },
    "shareArticle": "Artikel teilen",
    "tableOfContents": "Inhalt",
    "minuteRead": "Min. Lesezeit",
    "tags": "Tags",
    "latestArticles": "Neueste Artikel",
    "emptyTitle": "Keine Artikel",
    "emptySubtitle": "Derzeit sind keine Artikel veröffentlicht.",
    "articleNotFound": "Artikel nicht gefunden",
    "shopAnatomic": "Anatomische Hausschuhe ansehen",
    "ctaTitle": "Mehr Komfort für Ihre Füße mit anatomischen Hausschuhen",
    "viewProduct": "Produkt ansehen"
  },
  "Cart": {
    "title": "Warenkorb",
    "item": "Artikel",
    "items": "Artikel",
    "emptyTitle": "Ihr Warenkorb ist leer",
    "empty": "Ihr Warenkorb ist leer",
    "continueShopping": "Weiter einkaufen",
    "removeItem": "Artikel entfernen",
    "orderSummary": "Bestellübersicht",
    "subtotal": "Zwischensumme",
    "totalVatIncl": "Gesamt (inkl. MwSt.)",
    "shipping": "Lieferung",
    "calculatedAtCheckout": "Wird an der Kasse berechnet",
    "total": "Gesamt",
    "checkout": "Zur Kasse",
    "shoesColorNotice": "Wir bemühen uns, dass die Produktfotos die Farben und das Aussehen des Leders möglichst originalgetreu wiedergeben. Da wir jedoch echtes Leder verwenden und regelmäßig neue Chargen desselben Leders beziehen, können im Vergleich zum gezeigten Foto kleine Farbnuancen abweichen. Solche Unterschiede sind ein Merkmal des natürlichen Materials und beeinträchtigen weder die Qualität noch das Aussehen des Produkts.",
    "noteLabel": "Bestellnotiz",
    "notePlaceholder": "Schreiben Sie eine Notiz, besondere Lieferanweisungen oder eine Nachricht...",
    "optionName_Size": "Größe",
    "optionName_Color": "Farbe",
    "optionName_Material": "Material",
    "optionName_Style": "Stil",
    "optionName_Shoe size": "Größe",
    "checkoutConfirmation": {
      "title": "Vor Abschluss der Bestellung",
      "message": "Bevor Sie die Bestellung abschließen, möchten wir Sie darauf hinweisen, dass wir immer verfügbare Modelle in allen Größen für eine schnelle Lieferung haben.",
      "contactPrompt": "Für einen Überblick über aktuell verfügbare Modelle kontaktieren Sie uns gerne unter:",
      "phone": "099 280 7007",
      "email": "postolar.varga@gmail.com",
      "helpOffer": "Wir senden Ihnen gerne Fotos und helfen bei der Auswahl.",
      "continueToCheckout": "Weiter zur Kasse",
      "cancel": "Zurück"
    },
    "deliveryInfo": {
      "title": "Lieferzeit:",
      "standard": "Die Herstellungs- und Lieferzeit beträgt 7-14 Werktage.",
      "personalized": "Jeder Hausschuh ist handgefertigt, daher kann die Herstellung manchmal etwas länger dauern, damit wir Komfort und Qualität erhalten. Vielen Dank für Ihre Geduld."
    }
  },
  "Collections": {
    "title": "Kollektionen",
    "breadcrumbs": {
      "home": "Startseite",
      "collections": "Kollektionen"
    },
    "productCount": "{{count}} Produkte",
    "empty": "In dieser Kollektion gibt es keine Produkte.",
    "emptyTitle": "Keine Kollektionen gefunden",
    "emptySubtitle": "Schauen Sie später wieder vorbei, um neue Kollektionen zu entdecken.",
    "notFound": "Kollektion nicht gefunden",
    "backToCollections": "Zurück zu den Kollektionen",
    "loadMore": "Mehr Produkte laden",
    "showMore": "Mehr anzeigen",
    "showLess": "Weniger anzeigen",
    "subtitle": "Handgefertigte Hausschuhe, Sandalen und Lederwaren"
  },
  "Filters": {
    "filter": "Filter",
    "resetFilters": "Alle zurücksetzen",
    "showFilters": "Filter anzeigen",
    "hideFilters": "Filter ausblenden",
    "activeFilters": "Aktive Filter",
    "clearAll": "Alle löschen",
    "noResults": "Keine Produkte entsprechen den ausgewählten Filtern.",
    "noResultsHint": "Entfernen Sie einige Filter oder erweitern Sie Ihre Suche.",
    "resultsCount_one": "{{count}} Produkt",
    "resultsCount_few": "{{count}} Produkte",
    "resultsCount_other": "{{count}} Produkte",
    "productType": {
      "title": "Produkttyp",
      "handmadeShoes": "Handgefertigte Schuhe",
      "personalizedShoes": "Personalisierte Schuhe",
      "slippers": "Lederhausschuhe",
      "sandals": "Sandalen",
      "belts": "Gürtel",
      "bags": "Taschen",
      "backpacks": "Rucksäcke",
      "purseBags": "Handtaschen",
      "keychains": "Schlüsselanhänger",
      "eyewearCases": "Brillenetuis",
      "petAccessories": "Haustierzubehör",
      "groups": {
        "shoes": "Schuhe",
        "sandals": "Sandalen",
        "bags": "Taschen",
        "backpacks": "Rucksäcke",
        "leatherGoods": "Lederwaren",
        "belts": "Gürtel",
        "eyewearCases": "Brillenetuis",
        "keychains": "Schlüsselanhänger",
        "pets": "Haustiere"
      }
    },
    "color": {
      "title": "Farbe",
      "black": "Schwarz",
      "white": "Weiß",
      "red": "Rot",
      "blue": "Blau",
      "green": "Grün",
      "yellow": "Gelb",
      "pink": "Rosa",
      "brown": "Braun",
      "gray": "Grau",
      "navy": "Marineblau",
      "beige": "Beige",
      "silver": "Silber",
      "multicolor": "Mehrfarbig",
      "floral": "Blumenmuster",
      "geometric": "Geometrisches Muster",
      "animal": "Tiermuster",
      "clear": "Transparent"
    },
    "size": {
      "title": "Größe",
      "oneSize": "Einheitsgröße"
    },
    "price": {
      "title": "Preis",
      "min": "Min.",
      "max": "Max.",
      "range": "{{min}} – {{max}}"
    },
    "gender": {
      "title": "Geschlecht",
      "female": "Damen",
      "male": "Herren",
      "unisex": "Unisex"
    },
    "brands": "Marken",
    "vendors": "Kollektionen",
    "sort": "Sortieren",
    "sortOptions": {
      "default": "Standard",
      "best-selling": "Bestseller",
      "price-asc": "Preis: niedrig bis hoch",
      "price-desc": "Preis: hoch bis niedrig",
      "newest": "Neueste",
      "title-asc": "Name: A bis Z",
      "title-desc": "Name: Z bis A"
    },
    "availability": "Verfügbarkeit",
    "inStock": "Nur auf Lager",
    "mobile": {
      "title": "Filter",
      "showResults": "Ergebnisse anzeigen ({{count}})"
    }
  },
  "Homepage": {
    "loading": "Wird geladen...",
    "shopNow": "Jetzt einkaufen",
    "viewAll": "Alle ansehen",
    "noProducts": "Keine Produkte gefunden",
    "topCategories": "Top-Kategorien",
    "topSellers": "Bestseller",
    "newProducts": "Neue Produkte",
    "bestSellers": "Bestseller",
    "latestArticles": "Neueste Artikel",
    "readMore": "Weiterlesen",
    "discount": "{{value}}% RABATT",
    "viewProducts": "Produkte ansehen",
    "buyNow": "Jetzt kaufen",
    "topInfluencers": "Unsere Bestseller",
    "viewShop": "Shop ansehen",
    "giftCards": "Geschenkkarten!",
    "giftCard": "Geschenkkarte",
    "giftCardsDescription": "Ob Sie einen lieben Menschen überraschen, einem Freund gratulieren oder einem Kollegen danken möchten.",
    "followUs": "Folgen Sie uns",
    "hero": {
      "slide1": {
        "title": "Varga-Qualität",
        "subtitle": "Wir fertigen auch Taschen auf Bestellung!",
        "cta": "Taschen ansehen"
      },
      "slide2": {
        "title": "Hundehalsbänder und Leinen",
        "subtitle": "Handgefertigte Lederaccessoires für Ihre Haustiere",
        "cta": "Haustierzubehör ansehen"
      },
      "slide3": {
        "title": "Postolar Varga Hausschuhe",
        "subtitle": "Bequem bei jedem Schritt",
        "cta": "Hausschuhe ansehen"
      },
      "slide4": {
        "title": "Einzigartiger Ledergürtel",
        "subtitle": "Handgefertigt aus hochwertigem Leder",
        "cta": "Gürtel ansehen"
      }
    },
    "welcome": {
      "kicker": "Willkommen im Webshop",
      "title": "Postolar Varga - handgefertigte Produkte aus echtem Leder",
      "subtitle": "Wir fertigen unsere Produkte von Hand mit viel Liebe zum Detail. Ein Teil des Sortiments ist auf Bestellung und in personalisierten Varianten erhältlich. Im Mittelpunkt stehen Komfort, Langlebigkeit und ein einzigartiger Look."
    },
    "collections": {
      "anatomskePapuce": "Anatomische Hausschuhe",
      "personaliziranePapuce": "Personalisierte Hausschuhe",
      "ljetnePapuce": "Sommerhausschuhe",
      "sandale": "Sandalen",
      "torbe": "Taschen",
      "remenje": "Gürtel",
      "ljubimci": "Haustiere"
    },
    "filters": {
      "featured": "Empfohlen",
      "hoodies": "Winter",
      "sale": "% Sale %",
      "influencers": "Neu im Angebot",
      "topSellers": "Bestseller"
    },
    "signUpToNewsletter": {
      "title": "Abonnieren Sie unseren Newsletter",
      "point1": "Erhalten Sie exklusive Angebote",
      "point2": "Erfahren Sie als Erste, wenn eine neue Kollektion erscheint",
      "point3": "Bleiben Sie über alles rund um Postolar Varga informiert",
      "inputPlaceholder": "E-Mail-Adresse eingeben",
      "button": "Abonnieren",
      "subscriptionSuccess": "Abonnement erfolgreich",
      "subscriptionMessage": "Sie gehören jetzt zu einer exklusiven Gruppe, die die neuesten Nachrichten, Updates und Sonderangebote von unserem Team erhält.",
      "subscriptionError": "Fehler beim Abonnieren",
      "consentNote": "Mit der Anmeldung willigen Sie ein, unseren Newsletter per E-Mail zu erhalten. Sie können sich jederzeit abmelden.",
      "privacyLink": "Datenschutzerklärung",
      "inputLabel": "E-Mail-Adresse"
    },
    "followUsOnSocial": {
      "title": "Folgen Sie uns",
      "description": "Bleiben Sie mit Postolar Varga in den sozialen Medien verbunden, um die neuesten Updates, Aktionen und neuen Produkte zu sehen.",
      "instagram": "Auf Instagram folgen",
      "facebook": "Auf Facebook folgen"
    },
    "metadata": {
      "title": "Postolar Varga - handgefertigte anatomische Lederhausschuhe",
      "description": "Wir produzieren besonders bequeme Lederhausschuhe mit anatomischer Sohle. Naturleder und Handarbeit garantieren hochwertige anatomische Hausschuhe zu fairen Preisen."
    },
    "craft": {
      "kicker": "Aus der Werkstatt",
      "title": "Jedes Paar nähen wir von Hand, Schicht für Schicht",
      "heelAlt": "Fersen zweier Vargice-Hausschuhe in Nahaufnahme, handgenähter Rand und Sohle",
      "clogAlt": "Roter Vargice-Lederhausschuh mit Schnalle",
      "cta": "So bauen wir die Fersensporn-Einlage ein",
      "points": {
        "handmade": {
          "title": "Handgenäht",
          "body": "Jeden Hausschuh nähen und fertigen wir von Hand, mit Blick auf den Komfort Ihrer Füße."
        },
        "insole": {
          "title": "Anatomische Einlage",
          "body": "Auf der Sohle liegen Memory-Schaum und eine Lederdecksohle für einen weichen, stabilen Schritt."
        },
        "custom": {
          "title": "Anpassung auf Bestellung",
          "body": "Personalisierte Modelle und für Damengrößen 36 bis 42 eine Fersensporn-Einlage."
        }
      }
    }
  },
  "Navbar": {
    "loading": "Wird geladen...",
    "links": "Links",
    "searchButton": "Suchen",
    "products": "Alle Produkte",
    "collections": "Kollektionen",
    "blog": "Blog",
    "contact": "Kontakt",
    "shopLink": "postolarvarga.hr",
    "electronics": "Elektronik",
    "myAccount": "Mein Konto",
    "countries": {
      "croatia": "Hrvatski",
      "serbia": "Serbien",
      "bosnia": "Bosnien und Herzegowina",
      "montenegro": "Montenegro",
      "macedonia": "Nordmazedonien",
      "unitedStates": "USA",
      "europe": "English (EU)",
      "germany": "Deutsch"
    },
    "ggShopLink": "postolarvarga.hr",
    "selectYourCountry": "Sprache auswählen",
    "logoutSuccess": "Sie wurden erfolgreich abgemeldet.",
    "search": {
      "placeholder": "Produkte suchen...",
      "description": "Suchen Sie Produkte nach Name oder Marke.",
      "tryThese": "Probieren Sie diese aus",
      "notFound": "Leider konnten wir für \"{{term}}\" nichts finden"
    },
    "profileDropdown": {
      "title": "Mein Konto",
      "login": "Anmelden",
      "register": "Jetzt registrieren",
      "registerMessage": "{register} und exklusive Vorteile genießen.",
      "profile": "Profil",
      "orders": "Bestellungen",
      "addresses": "Adressen",
      "returnPolicy": "Rückgabebedingungen",
      "paymentOptions": "Zahlungsarten",
      "accountSettings": "Kontoeinstellungen",
      "logout": "Abmelden"
    }
  },
  "NotFound": {
    "title": "Seite nicht gefunden",
    "subtitle": "404",
    "description": "Ups! Die gesuchte Seite existiert nicht oder wurde verschoben.",
    "goBack": "Zurück",
    "startOver": "Zurück zur Startseite",
    "searchProducts": "Produkte ansehen"
  },
  "Notice": {
    "order-delay": "Hinweis zu Bestellverzögerungen",
    "order-delay-text": "Aufgrund erhöhter Nachfrage zwischen {{startDate}} und {{endDate}} kann die Bearbeitung von Bestellungen länger dauern als üblich.",
    "order-delay-banner-text": "Die Bearbeitung von Bestellungen kann sich verzögern ({{startDate}} - {{endDate}})",
    "okay": "Verstanden"
  },
  "PriceList": {
    "title": "Preisliste",
    "intro": "Wir veröffentlichen die Preisliste des Webshops jeden Tag bis 8 Uhr als .csv-Datei. Sie enthält Name, Artikelnummer, Verkaufspreis, Basispreis und Verfügbarkeit jedes Produkts. Frühere Preislisten bleiben hier mindestens 30 Tage abrufbar.",
    "current": "Aktuelle Preisliste",
    "archive": "Archiv",
    "published": "Veröffentlicht am {{date}}",
    "download": "Herunterladen",
    "empty": "Die Preisliste ist noch nicht veröffentlicht."
  },
  "ProductsPage": {
    "title": "Produkte",
    "count": "{{count}} Produkte",
    "loadMore": "Mehr laden",
    "emptyTitle": "Keine Produkte gefunden",
    "emptySubtitle": "Wir konnten keine Produkte finden, die Ihren Kriterien entsprechen. Entdecken Sie weitere Kategorien und handgefertigte Lederprodukte.",
    "discount": "{value}% RABATT",
    "outOfStock": "Nicht auf Lager",
    "metadata": {
      "title": "Alle Produkte - handgefertigte Lederprodukte von Postolar Varga",
      "description": "Entdecken Sie anatomische Hausschuhe, Sandalen, Taschen und Gürtel. Handgefertigte Lederprodukte von hoher Qualität."
    }
  },
  "Seo": {
    "homepage": {
      "title": "Postolar Varga - handgefertigte anatomische Lederhausschuhe",
      "description": "Wir produzieren besonders bequeme Lederhausschuhe mit anatomischer Sohle. Naturleder und Handarbeit garantieren hochwertige anatomische Hausschuhe zu fairen Preisen."
    },
    "products": {
      "title": "Alle Produkte - Postolar Varga",
      "description": "Entdecken Sie anatomische Hausschuhe, Sandalen, Taschen und Gürtel. Handgefertigte Lederprodukte von hoher Qualität."
    },
    "product": {
      "title": "{{name}} - Postolar Varga",
      "description": "Kaufen Sie {{name}} bei Postolar Varga. Hochwertige handgefertigte Lederprodukte mit Lieferung an Ihre Adresse."
    },
    "collections": {
      "title": "Kollektionen - Postolar Varga",
      "description": "Entdecken Sie alle Kollektionen mit anatomischen Hausschuhen, Sandalen, Taschen, Gürteln und mehr."
    },
    "collection": {
      "title": "{{name}} Kollektion - Postolar Varga",
      "description": "Entdecken Sie Produkte aus der Kollektion {{name}}."
    },
    "cart": {
      "title": "Warenkorb - Postolar Varga",
      "description": "Prüfen Sie Ihren Warenkorb und fahren Sie mit der Kasse fort."
    },
    "login": {
      "title": "Anmelden - Postolar Varga",
      "description": "Melden Sie sich in Ihrem Konto an, um Bestellungen zu verwalten und Sendungen zu verfolgen."
    },
    "register": {
      "title": "Konto erstellen - Postolar Varga",
      "description": "Erstellen Sie ein neues Konto, um bei uns einzukaufen und exklusive Vorteile zu genießen."
    },
    "forgotPassword": {
      "title": "Passwort zurücksetzen - Postolar Varga",
      "description": "Setzen Sie Ihr Passwort zurück, um wieder auf Ihr Konto zuzugreifen."
    },
    "resetPassword": {
      "title": "Passwort zurücksetzen - Postolar Varga",
      "description": "Setzen Sie Ihr Passwort zurück, um wieder auf Ihr Konto zuzugreifen."
    },
    "activate": {
      "title": "Konto aktivieren - Postolar Varga",
      "description": "Aktivieren Sie Ihr Konto, damit Sie einkaufen und Bestellungen verwalten können."
    },
    "faq": {
      "title": "Häufig gestellte Fragen - Postolar Varga",
      "description": "Finden Sie Antworten auf häufige Fragen zu Bestellungen, Lieferung und Rückgabe."
    },
    "securityAndPrivacy": {
      "title": "Datenschutzerklärung - Postolar Varga",
      "description": "Erfahren Sie, wie wir Ihre Daten und Privatsphäre schützen."
    },
    "paymentOptions": {
      "title": "Zahlungsarten - Postolar Varga",
      "description": "Sehen Sie sich die verfügbaren Zahlungsarten an."
    },
    "returnPolicy": {
      "title": "Rückgaberichtlinie - Postolar Varga",
      "description": "Rückgaberichtlinie: Widerruf innerhalb von 14 Tagen, Rücksendung und Erstattung."
    },
    "termsOfUse": {
      "title": "Allgemeine Geschäftsbedingungen - Postolar Varga",
      "description": "Allgemeine Geschäftsbedingungen des Onlineshops Postolar Varga: Bestellung, Zahlung, Lieferung, Widerruf und Beschwerden."
    },
    "orderingAndDelivery": {
      "title": "Lieferinformationen - Postolar Varga",
      "description": "Erfahren Sie, wie Sie bestellen und wie die Lieferung funktioniert."
    },
    "aboutUs": {
      "title": "Über uns - Postolar Varga",
      "description": "Erfahren Sie mehr über Postolar Varga, die Tradition handgefertigter Lederprodukte und unser Engagement für Komfort und Qualität."
    },
    "notFound": {
      "title": "Seite nicht gefunden - Postolar Varga",
      "description": "Die gesuchte Seite existiert nicht."
    },
    "account": {
      "title": "Mein Konto - Postolar Varga",
      "description": "Verwalten Sie Ihr Konto, Ihre Bestellungen und Einstellungen."
    },
    "orders": {
      "title": "Meine Bestellungen - Postolar Varga",
      "description": "Sehen Sie Ihre Bestellhistorie ein und verfolgen Sie Sendungen."
    },
    "order": {
      "title": "Bestellung #{{id}} - Postolar Varga",
      "description": "Details zur Bestellung #{{id}} ansehen."
    },
    "addresses": {
      "title": "Meine Adressen - Postolar Varga",
      "description": "Verwalten Sie Liefer- und Rechnungsadressen."
    },
    "profile": {
      "title": "Mein Profil - Postolar Varga",
      "description": "Aktualisieren Sie persönliche Daten und Einstellungen."
    },
    "blog": {
      "title": "Blog - Postolar Varga",
      "description": "Tipps zur Fußgesundheit, orthopädischen Hilfsmitteln und anatomischem Schuhwerk im Postolar Varga Blog."
    },
    "blogArticle": {
      "title": "{{name}} - Postolar Varga Blog",
      "description": "Lesen Sie den Artikel {{name}} im Postolar Varga Blog."
    },
    "withdrawalForm": {
      "title": "Widerrufsformular - Postolar Varga",
      "description": "Formular für den Widerruf eines Fernabsatzvertrags zum Herunterladen und Ausdrucken."
    },
    "contactInformation": {
      "title": "Kontakt - Postolar Varga",
      "description": "Kontaktdaten von Postolar Varga: Adresse, E-Mail und Telefon."
    },
    "complaints": {
      "title": "Beschwerden und Reklamationen - Postolar Varga",
      "description": "So reichen Sie eine schriftliche Beschwerde oder Reklamation ein: persönlich, per Post oder per E-Mail, mit Antwort innerhalb von 15 Tagen."
    },
    "cookies": {
      "title": "Cookie-Richtlinie - Postolar Varga",
      "description": "Welche Cookies wir verwenden, wozu, wie lange und wie Sie Ihre Einwilligung ändern oder widerrufen."
    },
    "withdraw": {
      "title": "Vertrag widerrufen - Postolar Varga",
      "description": "Widerrufen Sie Ihren Kauf über das Formular, ohne Anmeldung. Die Bestätigung mit Datum und Uhrzeit senden wir per E-Mail."
    },
    "priceList": {
      "title": "Preisliste - Postolar Varga",
      "description": "Tägliche Preisliste des Webshops als .csv-Datei mit Verkaufs- und Basispreisen, mit Archiv der früheren Preislisten."
    }
  },
  "SingleProductPage": {
    "legalGuarantee": {
      "trigger": "Ihre Rechte aus der gesetzlichen Gewährleistung",
      "title": "Gesetzliche Gewährleistung",
      "description": "Harmonisierter EU-Hinweis zur gesetzlichen Gewährleistung",
      "alt": "Harmonisierter EU-Hinweis: In der EU verkaufte Waren sind durch eine gesetzliche Gewährleistung von mindestens zwei Jahren geschützt. Entspricht die Ware nicht der Beschreibung oder funktioniert sie nicht wie vorgesehen, muss der Verkäufer eine kostenlose Reparatur oder einen Ersatz anbieten, in manchen Fällen eine Preisminderung oder Erstattung. Melden Sie das Problem dem Verkäufer und legen Sie einen Kaufnachweis vor."
    },
    "priceNote": "Preis inkl. MwSt., zzgl. Versandkosten.",
    "addToCart": "In den Warenkorb",
    "soldOut": "Ausverkauft",
    "outOfStock": "Nicht auf Lager",
    "notFound": "Produkt nicht gefunden",
    "backToProducts": "Zurück zu den Produkten",
    "size": "Größe",
    "color": "Farbe",
    "sizeChart": "Größentabelle",
    "quantity": "Menge",
    "decreaseQuantity": "Menge verringern",
    "increaseQuantity": "Menge erhöhen",
    "productAddedToCart": "Produkt in den Warenkorb gelegt",
    "close": "Schließen",
    "description": "Beschreibung",
    "details": "Details",
    "vendor": "Marke",
    "type": "Typ",
    "relatedProducts": "Das könnte Ihnen gefallen",
    "breadcrumbs": {
      "home": "Startseite",
      "products": "Produkte"
    },
    "descriptionAndSpecifications": "Beschreibung und Spezifikationen",
    "delivery": "Lieferung",
    "returns": "Rückgabe",
    "deliveryText": "Ihre Bestellung wird innerhalb von 7 bis 15 Werktagen versendet und geliefert. Jede Bestellung wird erst nach Aufgabe der Bestellung bearbeitet. Bei unerwarteten Verzögerungen werden Sie per E-Mail benachrichtigt. Wochenenden und Feiertage zählen nicht zur Bearbeitungszeit.",
    "returnsText": "Ihre Zufriedenheit hat für uns oberste Priorität. Deshalb tun wir alles, um den Einkauf so einfach und angenehm wie möglich zu machen. Wenn Sie dennoch nicht vollständig zufrieden sind, können Sie Artikel innerhalb von 28 Tagen nach Erhalt zurücksenden, sofern sie sich im Originalzustand befinden.",
    "youMayLike": "Das könnte Ihnen gefallen",
    "mostPopular": "Am beliebtesten",
    "topQuality": "Höchste Qualität",
    "cotton100": "100% Baumwolle",
    "outOfStockNotify": "Benachrichtigen",
    "outOfStockModal": {
      "title": "Bleiben Sie informiert!",
      "emailContact": "Vielen Dank für Ihr Interesse an unseren Produkten. Um die Verfügbarkeit eines Artikels zu prüfen, senden Sie bitte eine Anfrage an unser Team unter {email}.",
      "responseInfo": "Sie erhalten eine E-Mail-Benachrichtigung, wenn dieses Produkt wieder auf Lager ist."
    },
    "sizeGuide": {
      "openButton": "Größenberater",
      "title": "Größenberater",
      "description": "Messen Sie Ihre Fußlänge in Zentimetern und finden Sie die passende Größe.",
      "euSize": "EU-Größe",
      "footLength": "Fußlänge",
      "generalTitle": "Standardgrößen",
      "proTitle": "PRO-Modelle",
      "mensTitle": "Herrengrößen"
    },
    "width": "Breite (cm)",
    "height": "Höhe (cm)",
    "optionName": {
      "Size": "Größe",
      "Color": "Farbe",
      "Material": "Material",
      "Style": "Stil",
      "Shoe size": "Größe",
      "Dodatak": "Zusatz",
      "Title": "Titel"
    },
    "manufacturer": "Hersteller",
    "manufacturerCountry": "Kroatien"
  },
  "Withdrawal": {
    "title": "Vertrag widerrufen",
    "intro": "Sie können den Kaufvertrag innerhalb von 14 Tagen nach Erhalt der Sendung ohne Angabe von Gründen widerrufen. Geben Sie die Daten Ihrer Bestellung ein, prüfen Sie sie und bestätigen Sie den Widerruf.",
    "fields": {
      "name": "Vor- und Nachname",
      "orderNumber": "Bestellnummer",
      "orderNumberHint": "Steht in der Bestellbestätigung, z. B. 1124.",
      "email": "E-Mail-Adresse der Bestellung",
      "emailHint": "Dorthin senden wir die Eingangsbestätigung mit Datum und Uhrzeit."
    },
    "continue": "Weiter",
    "back": "Zurück",
    "reviewTitle": "Widerrufserklärung prüfen",
    "statement": "Hiermit widerrufe ich den Vertrag über den Kauf der folgenden Waren aus der Bestellung {{order}}:",
    "summary": {
      "name": "Name",
      "order": "Bestellung",
      "email": "E-Mail"
    },
    "confirm": "Widerruf bestätigen",
    "confirmNote": "Die Eingangsbestätigung mit Datum und Uhrzeit senden wir an {{email}}.",
    "doneTitle": "Widerruf eingegangen",
    "doneBody": "Wir haben Ihren Widerruf für die Bestellung {{order}} erhalten. Die Bestätigung mit Datum und Uhrzeit haben wir an {{email}} gesendet. Über die nächsten Schritte informieren wir Sie per E-Mail.",
    "errors": {
      "NOT_FOUND": "Wir finden keine Bestellung mit dieser Nummer und E-Mail-Adresse. Bitte prüfen Sie die Daten in der Bestellbestätigung.",
      "CANCELLED": "Diese Bestellung ist bereits storniert.",
      "NOTHING_TO_WITHDRAW": "In dieser Bestellung gibt es keine Waren mehr zum Zurücksenden. Wenn Sie das für einen Fehler halten, schreiben Sie uns an postolar.varga@gmail.com.",
      "REQUEST_FAILED": "Den Widerruf für diese Bestellung können wir über das Formular nicht annehmen, vielleicht wurde er schon eingereicht. Schreiben Sie uns an postolar.varga@gmail.com.",
      "SERVER_ERROR": "Etwas ist schiefgelaufen. Versuchen Sie es erneut oder schreiben Sie uns an postolar.varga@gmail.com.",
      "INVALID": "Bitte prüfen Sie Ihre Angaben."
    },
    "otherWays": {
      "start": "Sie können auch in Ihrem",
      "account": "Kundenkonto",
      "middle": "widerrufen oder uns das",
      "form": "Widerrufsformular",
      "end": "per E-Mail oder Post senden."
    }
  }
}